import axios from 'axios';
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'

import _ from "lodash";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import DonutLargeIcon from '@material-ui/icons/DonutLarge';

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'

import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import DeleteContractService from "../../services/contract/DeleteContractServices";
import NotesSingle from "../../components/Notes/NotesSingle";
import GetCompanyInfoService from "../../services/company/getCompanyInfoService";
import { useSubscriptionFeatures } from "../../contexts/SubscriptionContext";
import NewContractModal, { ENABLE_NEW_CONTRACT_COPY_MODAL } from "./components/NewContractModal";
import TemplateCopyService from "../../services/contract/templateCopyService";

const ContentCopyIcon = ({ style }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" style={style}>
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
);

function Contract({ customerPermission }) {
  const { planFeatures } = useSubscriptionFeatures();
  const tableRef = React.createRef();
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [selectedValue2, setSelectedValue2] = useState(null);

  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const [loading, setLoading] = useState(true);
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [object_name, setObject_name] = useState('Contract')
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [contractType, setContractType] = useState([
    'Lease',
    'Loan',
    'Rental',
    'Line of Credit'
  ]);
  const [filterContract_type, setFilterContract_type] = useState('')
  const [status, setStatus] = useState([
    'Active',
    'Entered',
    'PaidOff',
    'Template'
  ])
  const [filterstatus, setFilterstatus] = useState('')
  let navigate = useNavigate();
  var contractNumber = "";
  var customerName = "";
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [contract_typeval, setContract_typeval] = useState("")
  const [newContractType, setNewContractType] = useState(null)

  const location = useLocation();
  const pendingcontracts = location?.state;

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };


  // const handleView = (id, status, contract_type) => {

  //   if (status === "Active" || status === "PaidOff") {
  //     navigate("/contract/view", { state: id });
  //   } else if (status === "Terminated") {
  //     navigate("/contract/view", { state: id });
  //   } else {
  //     if (contract_type === "Loan") {
  //       navigate("/editloancontract", { state: id });
  //     } else if (contract_type === "Rental") {
  //       navigate("/editrentalcontract", { state: id });
  //     } else {
  //       navigate("/contract/edit", { state: id });
  //     }
  //   }
  // };

  const handleView = (id, status) => {
    if (
      status === "Active" ||
      status === "PaidOff" ||
      status === "Terminated"
    ) {
      navigate("/contract/view", { state: id });
    } else {
      navigate("/contract/view", { state: id });
    }
  };

  const handleEdit = (id, status, contract_type) => {

    if (
      status === "Active" ||
      status === "PaidOff" ||
      status === "Terminated"
    ) {
      toast.error("This contract cannot be edited");
      return;
    }
    const type = contract_type?.toLowerCase();
    console.log("Contract type for editing:", type); // Debug log
    if (type === "loan") {
      navigate("/editloancontract", { state: id });
    } else if (type === "rental") {
      navigate("/editrentalcontract", { state: id });
    } else if (type === "line of credit") {
      navigate("/edit-line-of-credit-contract", { state: id });
    } else {
      navigate("/contract/edit", { state: id });
    }
  };
  

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handlecontractLoan = ({ state }) => {
    // navigate("/createloancontract", { state });
    if (ENABLE_NEW_CONTRACT_COPY_MODAL) setNewContractType("Loan");
    else navigate("/create-loan", { state });
  };

  const handlecontractLease = ({ state }) => {
    // navigate("/contract/create", { state });
    if (ENABLE_NEW_CONTRACT_COPY_MODAL) setNewContractType("Lease");
    else navigate("/create-lease", { state });
  };

  const handlecontractRent = ({ state }) => {
    if (ENABLE_NEW_CONTRACT_COPY_MODAL) setNewContractType("Rental");
    else navigate("/create-rental", { state });
  };

  const handlecontractLineOfCredit = ({ state }) => {
    if (ENABLE_NEW_CONTRACT_COPY_MODAL) setNewContractType("Line of Credit");
    else navigate("/create-line-of-credit", { state });
  };

  const handleType = (event) => {
    const gettype = event.target.value;
    setFilterContract_type(gettype);
  };

  const handleStatus = (event) => {
    const getstatus = event.target.value;
    setFilterstatus(getstatus);
  };
  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2(null);
    setFilterContract_type('')
    setFilterstatus('')
    tableRef.current.onQueryChange();
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleCopy = (rowData) => {
    TemplateCopyService.copyContract(rowData.id, rowData.contract_type)
      .then((response) => {
        if (response.data.success === 1) {
          toast.success("Contract copied");
          handleEdit(response.data.contractID, "Entered", response.data.contract_type);
        } else {
          toast.error(response.data.error || "Unable to copy contract");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Unable to copy contract");
      });
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this contract?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeleteContractService.deletecontract(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                tableRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      // Modify the logic here to handle customerName if needed
      let customerName = "";
      let contractType = ""
      if (selectedValue) {
        customerName = selectedValue.id;
      }
      if (selectedValue2) {
        contractNumber = selectedValue2.contract_number
      } if (filterContract_type) {
        contractType = filterContract_type
      }

      const url = API + "contracts/contracts/0/?" + query.pageSize + "&status=" + filterstatus + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName + "&contract_type=" + contractType

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  const handleInputChangeData = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputValue, currentPage);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'financed_amount') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      } else {
        alignmentStyles[index] = { halign: 'left' }; // Left align for other fields
      }
    });
    return alignmentStyles;
  }

    const isNotesDisabled = planFeatures && planFeatures.notes === false;
    const isLineOfCreditDisabled = planFeatures && planFeatures.line_of_credit === false;

  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  }, [tableRef]);

  const handleContractNavigation = (path, { state }) => {
    navigate(path, { state });
  };

  useEffect(() => {
    GetCompanyInfoService.getCompanySettingInfo().then(
      (response) => {
        setContract_typeval(response.data.contract_type)
      }
    )
  }, [])

  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          {newContractType && (
            <NewContractModal contractType={newContractType} onClose={() => setNewContractType(null)} />
          )}
          <div className="content container-fluid">
            <div className="row show_contract show_invoice">
              <div className="">
                <div className="col-md-12 ">
                  <div className="">
                    <div className="body">
                      <div className=" p-0">
                        <MaterialTable
                          tableRef={tableRef}
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          title={<h5 className="mb-0">{t("Contracts")}</h5>}
                          columns={[
                            {
                              title: `${t("Contract Number")}`,
                              field: "contract_number",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              render: (rowData) => (
                                <>
                                  {" "}
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Contract Number")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      rowData.status === "Entered" ?
                                        permissionss && permissionsArray.includes('change_contract') === true &&
                                        customerPermission !== 'Customer' && handleView(
                                          rowData.id,
                                          rowData.status,
                                          rowData.contract_type
                                        ) :
                                        permissionss && permissionsArray.includes('view_contract') === true &&
                                          rowData.status === "ContractMod" ? "" :
                                          handleView(
                                            rowData.id,
                                            rowData.status,
                                            rowData.contract_type
                                          )

                                    }
                                  >
                                    {rowData.status === "ContractMod" ? rowData.contract_number + ' M' : rowData.contract_number}
                                  </div>
                                </>
                              ),
                            },
                            {
                              title: `${t("Customer")}`,
                              field: "customer_name",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Customer")}
                                  </div>{" "}
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      permissionss && permissionsArray.includes('view_party') === true ? customerPermission !== 'Customer' && handlePartyView(rowData.party) : null
                                    }
                                  >
                                    {rowData.customer_name}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Contract Type")}`,
                              field: "contract_type",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {" "}
                                    {t("Contract Type")}
                                  </div>
                                  <div>{rowData.contract_type}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.start_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Term")}`,
                              field: "contract_term",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Term")}
                                  </div>
                                  <div>{rowData.contract_term}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>
                                    {rowData.end_date
                                      ? Helper.DateNormal(rowData.end_date)
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Date")}`,
                              field: "paymentstartdate",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Date")}
                                  </div>
                                  <div>
                                    {rowData.paymentstartdate
                                      ? Helper.DateNormal(
                                        rowData.paymentstartdate
                                      )
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Termination Date")}`,
                              field: "termination_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Termination Date")}
                                  </div>
                                  <div>
                                    {rowData.termination_date
                                      ? Helper.DateNormal(
                                        rowData.termination_date
                                      )
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Financed Amount")}`,
                              field: "financed_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Financed Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.financed_amount === 0
                                      ? Helper.Amount(rowData.financed_amount)
                                      : Helper.Amount(
                                        rowData.financed_amount -
                                        rowData.deposit_amount
                                      )}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Status")}`,
                              field: "status",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Status")}
                                  </div>
                                  <div
                                    className={
                                      rowData.status === "Active"
                                        ? "badge bg-gradient-success text-xxs"
                                        : rowData.status === "Terminated" || rowData.status === "PaidOff"
                                          ? "badge bg-gradient-danger text-xxs"
                                          : "badge badge-sm bg-gradient-secondary"
                                    }
                                  >
                                    {rowData.status}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Notes")}`,
                              field: "",
                              hidden: customerPermission !== 'Customer' ? false : true,
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Notes")}
                                  </div>
                                  <div
                                    onClick={() => {
                                    if (isNotesDisabled) return; 
                                    setIsSidePanelOpen(true);
                                    setSelectedRowId(rowData.id);
                                  }}
                                  style={{
                                    opacity: isNotesDisabled ? 0.5 : 1,
                                    cursor: isNotesDisabled ? 'not-allowed' : 'pointer',
                                    filter: isNotesDisabled ? 'grayscale(100%)' : 'none'
                                  }}

                                  >
                                    <span className="cursor-pointer">
                                      {rowData.has_notes ?
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                                          }
                                          alt="notes"
                                          height='30px'
                                          width='30px'
                                        /> :
                                        <><img
                                          src={process.env.PUBLIC_URL +
                                            "/static/images/iconplus.png"}
                                          alt="notes"
                                          height='22px'
                                          width='22px' />
                                        </>

                                      }
                                      {isNotesDisabled && <span style={{fontSize: '10px', marginLeft: '2px'}}>🔒</span>}
                                    </span>
                                  </div>
                                  {isSidePanelOpen && selectedRowId === rowData.id && (
                                    <NotesSingle
                                      setIsSidePanelOpen={setIsSidePanelOpen}
                                      isSidePanelOpen={isSidePanelOpen}
                                      state={selectedRowId}
                                      object_name={object_name}
                                    />
                                  )}
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            // {
                            //   title: `${t("Action")}`,
                            //   field: "",
                            //   hidden: customerPermission === 'Customer',
                            //   render: (rowData) => (
                            //     <>
                            //       <div className="d-xl-none tc d-md-none d-lg-none">
                            //         {t("Action")}
                            //       </div>
                            //       <div>
                            //         {rowData.status === "Entered" ? (
                            //           permissionss && permissionsArray.includes('delete_contract') === true ?
                            //             <span className="cursor-pointer">
                            //               <img
                            //                 src={
                            //                   process.env.PUBLIC_URL +
                            //                   "/static/images/ic-delete.svg"
                            //                 }
                            //                 onClick={() =>
                            //                   handleDelete(rowData.id)
                            //                 }
                            //                 alt="Delete icon"
                            //               />
                            //             </span>
                            //             : ""
                            //         ) : (
                            //           <Tooltip title="Processing" placement="right">
                            //           {rowData.status==="ContractMod"?"":
                            //             <span onClick={() => navigate('/processing',
                            //               {
                            //                 state: {
                            //                   id: rowData.id,
                            //                   contract_number: rowData.contract_number
                            //                 },
                            //               }
                            //             )}>
                            //               <DonutLargeIcon style={{ cursor: 'pointer' }} />
                            //             </span>
                            //           }
                            //           </Tooltip>

                            //         )}
                            //       </div>
                            //     </>
                            //   ),
                            //   headerStyle: {
                            //     verticalAlign: "inherit",
                            //     fontWeight: "bold",
                            //     textAlign: "left",
                            //   },
                            //   cellStyle: {
                            //     textAlign: "left",
                            //     fontSize: 10,
                            //   },
                            // },

                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              const { orderBy, orderDirection } = query;

                              if (selectedValue2 && selectedValue) {
                                contractNumber = selectedValue2.contract_number;
                                customerName = selectedValue.id;
                              } else if (selectedValue2) {
                                contractNumber = selectedValue2.contract_number;
                              } else if (selectedValue) {
                                customerName = selectedValue.id;
                              }
                              let url = API + "contracts/contracts/0/?";
                              url += `status=${pendingcontracts !== null ? pendingcontracts : filterstatus !== "" ? filterstatus : ''
                                }`;
                              url += "&per_page=" + query.pageSize;
                              url += "&page=" + (query.page + 1);
                              url += "&search=" + query.search;
                              url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""
                                }`;
                              url += `&customerName=${customerName !== "" ? customerName : ""
                                }`;
                              url += `&contract_type=${filterContract_type !== "" ? filterContract_type : ""
                                }`;
                              // url += `&status=${filterstatus !== "" ? filterstatus : ""
                              //   }`;
                              if (orderBy) {
                                url += `&orderBy=${orderBy.field}`;
                                url += `&orderDirection=${orderDirection}`;
                              }
                              fetch(url, { headers: authHeader() })
                                .then((response) => response.json())
                                .then((result) => {
                                  resolve({
                                    data:
                                      query.orderBy && query.orderDirection
                                        ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                        : result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                  });
                                });
                            })
                          }

                          actions={[

                            (rowData) => ({
                              icon: () => (
                                <ContentCopyIcon
                                  style={{
                                    cursor: "pointer",
                                    fontSize: 20,
                                    visibility:
                                      rowData.status === "ContractMod" || rowData.status === "Archived"
                                        ? "hidden"
                                        : "visible",
                                  }}
                                />
                              ),
                              tooltip: "Copy",
                              onClick: (event, rowData) => {
                                if (
                                  rowData.status !== "ContractMod" &&
                                  rowData.status !== "Archived" &&
                                  permissionsArray.includes('add_contract')
                                ) {
                                  handleCopy(rowData);
                                }
                              },
                              disabled: !permissionsArray.includes('add_contract'),
                            }),

                            (rowData) => ({
                              icon: () => (
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                                  alt="edit"
                                  style={{
                                    visibility:
                                      (rowData.status === "Entered" || rowData.status === "Template")
                                        ? "visible"
                                        : "hidden",
                                  }}
                                />
                              ),
                              tooltip: "Edit",
                              onClick: (event, rowData) => {
                                if (
                                  (rowData.status === "Entered" || rowData.status === "Template")
                                  // permissionsArray.includes('edit_contract')
                                ) {
                                  handleEdit(rowData.id, rowData.status, rowData.contract_type);
                                }
                              },
                              disabled:
                                rowData.status === "Active" 
                                // !permissionsArray.includes('edit_contract'),
                            }),


                            (rowData) => ({
                              icon: () => {
                                if (rowData.status === "Entered" || rowData.status === "Template") {
                                  return (
                                    <img
                                      src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                                      alt="delete"
                                    />
                                  );
                                }

                                if (rowData.status === "ContractMod") {
                                  return <span style={{ width: "20px" }}></span>;
                                }

                                return <DonutLargeIcon style={{ cursor: "pointer" }} />;
                              },

                              tooltip:
                                (rowData.status === "Entered" || rowData.status === "Template")
                                  ? "Delete"
                                  : rowData.status === "ContractMod"
                                    ? ""
                                    : "Processing",

                              onClick: (event, rowData) => {
                                if (rowData.status === "Entered" || rowData.status === "Template") {
                                  if (permissionsArray.includes('delete_contract')) {
                                    handleDelete(rowData.id);
                                  }
                                } else if (rowData.status !== "ContractMod") {
                                  navigate('/processing', {
                                    state: {
                                      id: rowData.id,
                                      contract_number: rowData.contract_number,
                                    },
                                  });
                                }
                              },

                              disabled:
                                (rowData.status === "Entered" || rowData.status === "Template")
                                  ? !permissionsArray.includes('delete_contract')
                                  : false,
                            }),

                          ]}

                          localization={{
                            toolbar: {
                              searchPlaceholder: "Search Contracts",
                            },
                          }}
                          components={{
                            Toolbar: (props) => (
                              <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                                <MTableToolbar {...props} />
                                <span
                                  onClick={() => setState({ isPaneOpen: true })}
                                  style={{
                                    color: "#b4b7c5",
                                    paddingRight: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/static/images/ic-filter.svg"
                                    }
                                    alt="Filter Icon"
                                  />
                                </span>
                                {customerPermission !== 'Customer' &&
                                  <div className="dropdown">
                                    {
                                      permissionss && permissionsArray.includes('add_contract') === true ?
                                        <button
                                          className="btn btn-primary mb-0 dropdown-toggle"
                                          data-bs-toggle="dropdown"
                                          type="button"
                                        >
                                          +&nbsp;{t("New Contract")}
                                        </button> : ""
                                    }
                                    <ul
                                      style={{ padding: "15px" }}
                                      className="dropdown-menu  "
                                    >
                                      <li>
                                        <span
                                          onClick={() =>
                                            handlecontractLease({
                                              state: "Lease",
                                            })
                                          }
                                        >
                                          Lease
                                        </span>

                                      </li>
                                      <li>
                                        <span
                                          onClick={() =>
                                            handlecontractLoan({ state: "Loan" })
                                          }
                                        >
                                          Loan
                                        </span>
                                      </li>
                                      <li>
                                        <span
                                          onClick={() =>
                                            handlecontractRent({
                                              state: "Rental",
                                            })
                                          }
                                        >
                                          Rental
                                        </span>
                                      </li>
                                      {!isLineOfCreditDisabled && (
                                        <li>
                                          <span
                                            onClick={() =>
                                              handlecontractLineOfCredit({
                                                state: "Line of Credit",
                                              })
                                            }
                                          >
                                            Line of Credit
                                          </span>
                                        </li>
                                      )}
                                    </ul>
                                  </div>}
                                {/* {customerPermission !== 'Customer' &&
                                  <div className="dropdown">
                                    {
                                      permissionss && permissionsArray.includes('add_contract') === true ?
                                        <button
                                          className="btn btn-primary mb-0 dropdown-toggle"
                                          data-bs-toggle="dropdown"
                                          type="button"
                                        >
                                          +&nbsp;{t("New Contract")}
                                        </button> : ""
                                    }
                                    <ul
                                      style={{ padding: "15px" }}
                                      className="dropdown-menu "
                                    >
                                      <li>
                                        {contract_typeval &&
                                          contract_typeval.split(",").map((type, index) => {
                                            const trimmedType = type.trim();
                                            const contractRoutes = {
                                              Lease: "/contract/create",
                                              Loan: "/createloancontract",
                                              Rental: "/createrentalcontract",
                                            };

                                            return (
                                              <span
                                                key={index}
                                                className="dropdown-item"
                                                onClick={() =>
                                                  handleContractNavigation(contractRoutes[trimmedType], { state: trimmedType })
                                                }
                                              >
                                                {t(trimmedType)}
                                              </span>
                                            );
                                          })}

                                      </li>
                                    </ul>
                                  </div>} */}
                              </div>
                            ),
                          }}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 11,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: true,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 20, 25, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: true,
                            exportFileName: "Contracts",
                            exportCsv: async (columns, data) => {
                              try {
                                const allData = await fetchAllDataForExport(); // Fetch all data
                                if (selectedValue !== null) {
                                  var selectedVal = selectedValue.customer_name
                                }
                                if (selectedValue2 !== null) {
                                  var selectedVal2 = selectedValue2.contract_number
                                }
                                const title = "Contract Report";
                                const currentDate = new Date().toLocaleDateString();

                                const csvContentWithInfo = `${title}\n ${selectedValue !== null ? `Fiter By Customer Name : ${selectedVal}\n` : ''} ${selectedValue2 !== null ? `Fiter By Contract Number : ${selectedVal2}\n` : ''} ${filterContract_type !== '' ? `Filter By Contract Type : ${filterContract_type}\n` : ''} ${filterstatus !== '' ? `Filter By Contract Status : ${filterstatus}\n` : ''} Date: ${currentDate}\n \n\n`;
                                const csvColumns = columns.map(columnDef => columnDef.title);
                                const csvData = allData.map(rowData => {
                                  const rowDataArray = columns.map(columnDef => {
                                    if (columnDef.field === "customer_name") {
                                      return rowData.customer_name ? rowData.customer_name : "";
                                    } else if (columnDef.field === 'start_date') {
                                      return rowData.start_date ? Helper.DateNormal(rowData.start_date)
                                        : "";
                                    }
                                    else if (columnDef.field === 'end_date') {
                                      return rowData.end_date ? Helper.DateNormal(rowData.end_date)
                                        : "";
                                    }
                                    else if (columnDef.field === 'paymentstartdate') {
                                      return rowData.paymentstartdate ? Helper.DateNormal(rowData.paymentstartdate)
                                        : "";
                                    }
                                    else {
                                      return rowData[columnDef.field];
                                    }
                                  });
                                  return rowDataArray;
                                });

                                const csvRows = [csvColumns, ...csvData];
                                const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;
                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = 'contract.csv';
                                link.style.display = 'none';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } catch (error) {
                                console.error("Error exporting CSV:", error);
                              }
                            },
                            exportPdf: async (columns, data) => {
                              const allData = await fetchAllDataForExport(); // Fetch all data
                              if (allData.length === 0) {
                                console.error("No data found for PDF export");
                                return;
                              }
                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);

                              const title = "Contract Report";
                              doc.text(title, 14, 10);

                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date: ${currentDate}`, 14, 15);

                              if (selectedValue !== null || selectedValue2 !== null) {
                                const selectedVal = selectedValue?.customer_name;
                                const selectedVal2 = selectedValue2?.contract_number;
                                if (selectedValue !== null & selectedValue2 !== null) {
                                  doc.text(`Filter By Customer Name and Contract Number : ${selectedVal === 'undefined' ? "" : selectedVal} and ${selectedVal2 === 'undefined' ? "" : selectedVal2}`, 14, 20);
                                }
                                else if (selectedValue !== null) {
                                  doc.text(`Filter By Customer Name : ${selectedVal === 'undefined' ? "" : selectedVal} `, 14, 20);
                                }
                                else if (selectedValue2 !== null) {

                                  doc.text(`Filter By  Contract Number : ${selectedVal2 === 'undefined' ? "" : selectedVal2}`, 14, 20);
                                }
                                else if (filterContract_type !== '') {
                                  doc.text(`Filter By  Contract type : ${filterContract_type === 'undefined' ? "" : filterContract_type}`, 14, 20);
                                }
                                else if (filterstatus !== '') {
                                  doc.text(`Filter By  Contract status : ${filterstatus === 'undefined' ? "" : filterstatus}`, 14, 20);
                                }
                              }
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;
                              const columnTitles = columns.map(columnDef => columnDef.title);
                              const pdfData = allData.map(rowData =>
                                columns.map(columnDef => {
                                  if (columnDef.field === "customer_name") {
                                    return rowData.customer_name ? rowData.customer_name : "";
                                  } else if (columnDef.field === 'start_date' || columnDef.field === 'end_date' || columnDef.field === 'paymentstartdate') {
                                    return rowData[columnDef.field] ? Helper.DateNormal(rowData[columnDef.field]) : "";
                                  } else {
                                    return rowData[columnDef.field];
                                  }
                                })
                              );
                              const tableData = [columnTitles, ...pdfData];

                              // doc.autoTable({
                              autoTable(doc, {
                                head: [tableData[0]], // Column headers
                                body: tableData.slice(1), // Data excluding headers
                                startY: tableStartY,
                                columnStyles: getAlignmentStyles(columns) // Apply column alignment styles
                              });

                              doc.save(`contract.pdf`);
                            },
                            actionsColumnIndex: -1,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <SlidingPane
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={state1.isPaneOpen}
                    title="Filter By"
                    subtitle=""
                    onRequestClose={() => {
                      setState({ isPaneOpen: false });
                    }}
                  >
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Customer Name")}
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={selectedValue}
                            filterOption={false}
                            options={options2}
                            isClearable
                            onInputChange={handelInputChange}
                            getOptionLabel={(options) => options.customer_name}
                            getOptionValue={(options) => options.customer_name}
                            isLoading={isLoading2}
                            placeholder={t("Search for Customer(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottomName}
                            onChange={handelChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Contract Number")}
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={selectedValue2}
                            filterOption={false}
                            options={options}
                            isClearable
                            onInputChange={handleInputChangeData}
                            getOptionLabel={(options) => options.contract_number}
                            getOptionValue={(options) => options.contract_number}
                            isLoading={isLoading}
                            placeholder={t("Search for Contract(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            onChange={handelChange2}
                          />
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Contract Type")}
                        </label>
                        <div className="col-lg-12">
                          <select
                            name="type"
                            className="form-control"
                            onChange={handleType}
                            value={filterContract_type}
                          >
                            <option value="">---Select Contract Type---</option>
                            {contractType.map((resst, i) => (
                              <option key={i} value={resst}>
                                {resst}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Contract Status")}
                        </label>
                        <div className="col-lg-12">
                          <select
                            name="status"
                            className="form-control"
                            onChange={handleStatus}
                            value={filterstatus}
                          >
                            <option value="">---Select Contract Status---</option>
                            {status.map((resst, i) => (
                              <option key={i} value={resst}>
                                {resst}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <div
                          className="col-lg-12 text-left"
                          style={{ marginTop: "30px" }}
                        >
                          <button
                            type="button"
                            className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                            onClick={handleClear}
                          >
                            {t("Reset")}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            className="filter add btn btn-primary btn-m ms-auto mb-0"
                            onClick={() => Helper.handleSearch(tableRef)}
                          >
                            {t("Apply")}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </div>
                  </SlidingPane>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default Contract;
